import React from "react";
const IconLens = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
    <path
      d="M13.6 12.6 18 17m-2.8-8.4A5.6 5.6 0 1 1 4 8.6a5.6 5.6 0 0 1 11.2 0Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="bevel"
    />
  </svg>
);
export default IconLens;
